import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import googleTagManager from "@analytics/google-tag-manager";
import Hotjar from "@hotjar/browser";
import { createTheme } from "@mui/material/styles";
import Analytics from "analytics";

import { generalThemeConfig } from "../theme/theme";

let hotjarInitialized = false;

export const useBrandedTheme = () => {
  const { i18n } = useTranslation();
  const branding = useBranding();

  const fontFamily = i18n.language === "ar" ? "Changa, sans-serif" : "Poppins, sans-serif";
  const theme = createTheme({
    ...generalThemeConfig,
    palette: branding ? branding.palette : generalThemeConfig.palette,
    typography: {
      ...generalThemeConfig.typography,
      fontFamily: fontFamily,
    },
  });

  return theme;
};

export const useBranding = () => {
  useEffect(() => {
    const brandingConfig = window.brandingConfig;
    if (brandingConfig) {
      document.title = brandingConfig.appTitle || "Members";
      const favicon = document.getElementById("favicon");
      if (favicon) {
        favicon.setAttribute("href", brandingConfig.assets.favicon);
      }
    }
  }, []);

  return window.brandingConfig;
};

export const useAnalytics = () => {
  const branding = useBranding();

  if (!branding) return;

  const analytics = Analytics({
    app: branding.appTitle,
    plugins: [
      googleTagManager({
        containerId: branding.analyticsId,
      }),
    ],
  });

  return analytics.page();
};

export const useHotjar = () => {
  const branding = useBranding();

  useEffect(() => {
    if (hotjarInitialized || !branding?.hotjar) return;

    const siteId = Number(branding.hotjar.siteId);
    const hotjarVersion = Number(branding.hotjar.hotjarVersion);

    if (!Number.isInteger(siteId) || siteId <= 0) return;
    if (!Number.isInteger(hotjarVersion) || hotjarVersion <= 0) return;

    Hotjar.init(siteId, hotjarVersion, branding.hotjar.options);
    hotjarInitialized = true;
  }, [branding]);
};

export {
  useSetDocumentDir,
  useDir,
  useProductTranslations,
  usePaymentPlanTranslations,
  useClassesTranslations,
} from "./language";
export {
  useMemberProfile,
  useTransactionHistory,
  useMemberProducts,
  useMemberContracts,
  useRenewalPlans,
  useFirstTimePlans,
  usePtProductBundles,
  useAvailableClasses,
  useClassDetails,
  useTrainerDetails,
  useSaudiStates,
  useSaudiCities,
  usePendingPayments,
  useMemberProfilePhoto,
  useClassBookings,
  useContractPayments,
  usePaymentMethodsManagement,
} from "./DataFetching";
